import PropertyInfo from './PropertyInfo';

export default PropertyInfo;
